import React, { useState, useEffect } from 'react';

// Services
import { paymentStatuses } from 'services/constants';

// Components
import SelectMultiple from 'components/select-multiple';

// ---------------------------------------------------------------------------------------------- \\
// ----------------------------------- SELECT PAYMENT STATUSES ---------------------------------- \\
// ---------------------------------------------------------------------------------------------- \\

const SelectPaymentStatuses = ({ statuses, setStatuses }) => {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        setOptions(paymentStatuses.map(s => ({ label: s.label, value: s.value })));
    }, []);

    return (
        <SelectMultiple
            value={statuses}
            onChange={value => setStatuses(value)}
            options={options}
            placeholder="Statut paiement"
        />
    );
};

export default SelectPaymentStatuses;
